import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("strong", { class: "text-xl leading-8 block font-normal text-gray-500 mt-[1.3333333em]" }, "Every TLD registry maintains data about registered domain names. They publish this data over the WHOIS protocol. Currently, 36 registries publish the location of their WHOIS servers using SRV records.", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", { class: "mt-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-full rounded-lg",
    src: "/img/learning/finding-whois-servers-using-srv-records/finding-whois-servers-using-srv-records.jpg",
    alt: "Finding the correct WHOIS server for a domain name isn't trivial",
    title: "Finding the correct WHOIS server for a domain name isn't trivial",
    width: "1200",
    height: "600"
  }),
  /*#__PURE__*/_createElementVNode("figcaption", null, [
    /*#__PURE__*/_createTextVNode("Finding the correct WHOIS server for a domain name isn't trivial. By NsLookup.io. Licensed under "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://creativecommons.org/licenses/by/4.0/",
      title: "Creative Commons By 4.0 licence",
      rel: "nofollow"
    }, "CC By 4.0"),
    /*#__PURE__*/_createTextVNode(".")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("code", null, ".de", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("pre", null, "❯ dig +short _nicname._tcp.de srv\n0 0 43 whois.denic.de.\n", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("I've queried the SRV records for every TLD according to "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://data.iana.org/TLD/tlds-alpha-by-domain.txt",
    rel: "noopener"
  }, "ICANN's TLD list"),
  /*#__PURE__*/_createTextVNode(" on 2023-05-15. This show that out of the 1479 TLDs, only 36 have adopted this practice. That's less than 2.5%.")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "After 50 years of WHOIS, it is — ironically — still hard to know who the authoritative WHOIS server is.", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "This is the full list of TLDs that publish the location of their WHOIS servers using SRV records as of 2023-05-15:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("table", null, [
  /*#__PURE__*/_createElementVNode("thead", null, [
    /*#__PURE__*/_createElementVNode("th", null, "TLD"),
    /*#__PURE__*/_createElementVNode("th", null, "WHOIS server")
  ]),
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "AM"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.amnic.net.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "AT"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.nic.at.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "AX"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.ax.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "BE"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.dns.be.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "BG"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.register.bg.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "BIZ"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.nic.biz.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "CH"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.nic.ch.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "CL"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.nic.cl.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "CO"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.nic.co.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "DE"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.denic.de.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "DK"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.dk-hostmaster.dk.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "FO"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.nic.fo.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "FR"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.nic.fr.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "GG"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.gg.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "HU"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.nic.hu.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "IS"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.isnic.is.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "JE"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.je.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "LA"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.nic.la.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "LI"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.nic.ch.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "LU"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.dns.lu.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "MD"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.nic.md.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "MX"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.nic.mx.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "NO"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.norid.no.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "NZ"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.srs.net.nz.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "PM"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.nic.pm.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "PW"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.centralnic.com.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "RE"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.nic.re.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "SE"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.nic-se.se.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "SI"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.register.si.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "TF"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.nic.tf.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "UA"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.ua.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "UK"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.nic.uk.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "US"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.nic.us.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "WF"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.nic.wf.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "XN--Y9A3AQ (հայ)"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.amnic.net.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "YT"),
      /*#__PURE__*/_createElementVNode("td", null, "whois.nic.yt.")
    ])
  ])
], -1)

import BlogPost from '@/components/layout/BlogPost.vue';

import { ruurtjan } from '@/common/authors';
import { BlogMeta } from '@/common/blogMeta';
import { learningBreadcrumb } from '@/model/Breadcrumb';

const meta: BlogMeta = {
  tag: 'Domain names',
  url: '/learning/finding-whois-servers-using-srv-records/',
  breadcrumbs: [learningBreadcrumb],
  title: 'Finding WHOIS servers using SRV records',
  description: 'Every TLD registry publishes data about registered domain names using WHOIS. 36 registries publish the location of their WHOIS servers using SRV records.',
  overviewImage: '/img/learning/finding-whois-servers-using-srv-records/finding-whois-servers-using-srv-records-small.jpg',
  overviewImageAlt: 'Finding WHOIS servers using SRV records',
  overviewDescription: 'Every TLD registry publishes data about registered domain names using WHOIS. 36 registries publish the location of their WHOIS servers using SRV records.',
  author: ruurtjan,
  editor: undefined,
  img1024x512: 'https://www.nslookup.io/img/learning/finding-whois-servers-using-srv-records/finding-whois-servers-using-srv-records-social.jpg',
  img1200x630: 'https://www.nslookup.io/img/learning/finding-whois-servers-using-srv-records/finding-whois-servers-using-srv-records-social.jpg',
  written: new Date('2023-05-15T13:42:15.009Z'),
  updated: undefined,
};

const __default__ = {
  meta,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'FindingWhoisServersUsingSrvRecords',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CodeBlock = _resolveComponent("CodeBlock")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(" { \"@context\": \"https://schema.org\", \"@type\": \"ImageObject\", \"author\": { \"@type\": \"Person\", \"email\": \"mailto:ruurtjan@nslookup.io\", \"image\": \"https://www.nslookup.io/img/ruurtjan-lg.jpg\", \"jobTitle\": \"CEO\", \"name\": \"Ruurtjan Pul\", \"url\": \"https://www.nslookup.io/about/ruurtjan-pul/\" }, \"copyrightHolder\": { \"@type\": \"Organization\", \"url\": \"https://www.nslookup.io/\", \"email\": \"hello@nslookup.io\" }, \"copyrightYear\": 2023, \"contentUrl\": \"https://www.nslookup.io/img/learning/finding-whois-servers-using-srv-records/finding-whois-servers-using-srv-records.jpg\", \"license\": \"https://creativecommons.org/licenses/by/4.0/\", \"acquireLicensePage\": \"https://creativecommons.org/licenses/by/4.0/\" } ")
        ]),
        _: 1
      }))
    ])),
    _createVNode(BlogPost, {
      title: meta.title,
      description: meta.description,
      url: `https://www.nslookup.io${meta.url}`,
      breadcrumbs: meta.breadcrumbs,
      img1024x512: meta.img1024x512,
      img1200x630: meta.img1200x630,
      written: meta.written,
      updated: meta.updated,
      author: meta.author,
      editor: meta.editor
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2,
        _createElementVNode("p", null, [
          _createTextVNode("For example, the "),
          _hoisted_3,
          _createTextVNode(" TLD registry publishes the location of its WHOIS server in an "),
          _createVNode(_component_router_link, { to: "/learning/dns-record-types/srv/" }, {
            default: _withCtx(() => [
              _createTextVNode("SRV record")
            ]),
            _: 1
          }),
          _createTextVNode(":")
        ]),
        _createVNode(_component_CodeBlock, null, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _hoisted_9
      ]),
      _: 1
    }, 8, ["title", "description", "url", "breadcrumbs", "img1024x512", "img1200x630", "written", "updated", "author", "editor"])
  ], 64))
}
}

})